import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-content: center;\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: ', 'px;\n  width: 100%;\n'], ['\n  align-content: center;\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: ', 'px;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n'], ['\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n']);

import styled from 'styled-components';
import { colors } from '@atlaskit/theme';
import { BORDER_WIDTH } from './constants';

// set fallbacks for border color/width to protect consumers from invalid values
export var Outer = styled.span(_templateObject, function (props) {
  return props.bgColor || colors.background;
}, function (_ref) {
  var size = _ref.size;
  return BORDER_WIDTH[size] || BORDER_WIDTH.medium;
});

export var Inner = styled.span(_templateObject2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/avatar/dist/esm/styled/Icon.js
// module id = 316
// module chunks = 0